import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { Feather, MaterialIcons } from "@expo/vector-icons";
import Colors from "../../../Resources/Color";
import { useTranslation } from "react-i18next";

export default function ExerciseSelectionPlaceholder({
  onCancel,
  onOpen,
  setAnchorNode,
}) {
  const { t } = useTranslation();
  return (
    <TouchableOpacity
      style={[styles.exerciseCard, styles.selectionPlaceholder]}
      activeOpacity={0.9}
      title={t("select-string")}
      onPress={onOpen}
    >
      {/*
        IMPORTANT (web): the floating search needs a real DOM element anchor.
        TouchableOpacity may not forward refs reliably in RN-web, so we anchor
        to an absolutely positioned host View.
      */}
      <View
        ref={(node) => setAnchorNode?.(node || null)}
        pointerEvents="none"
        style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
      />
      <View style={styles.exerciseHeader}>
        <View style={styles.exerciseMoveHandle}>
          <MaterialIcons
            name="drag-indicator"
            size={16}
            color={Colors.grayColor}
            style={{ opacity: 0.5 }}
          />
        </View>

        <View style={styles.exerciseTitleBlock} pointerEvents="none">
          <Text style={styles.selectionPlaceholderText}>{t("selectExercisePlaceholder-string")}</Text>
        </View>

        <View style={styles.exerciseHeaderActions} />
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  exerciseCard: {
    paddingVertical: 6,
    paddingHorizontal: 4,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "transparent",
    outlineStyle: "none",
    gap: 10,
  },
  exerciseHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    paddingVertical: 0,
    borderRadius: 10,
  },
  exerciseMoveHandle: {
    padding: 2,
  },
  exerciseTitleBlock: {
    flex: 1,
    minWidth: 0,
    gap: 2,
  },
  exerciseHeaderActions: {
    flexDirection: "row",
    gap: 4,
  },
  iconButton: {
    padding: 4,
  },
  selectionPlaceholder: {
    borderColor: Colors.bubbleColor,
    backgroundColor: "rgba(63, 123, 141, 0.05)",
    borderStyle: "solid",
  },
  selectionPlaceholderText: {
    fontSize: 13,
    fontWeight: "500",
    color: Colors.bubbleColor,
    fontStyle: "italic",
  },
});
